import { Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import React from 'react';
import { UtilsDate } from '../../../../app/orussystem/utils/UtilDate';
import { UtilsTable } from '../../../../app/orussystem/utils/UtilTable';
import { GraficasStyles } from '../GraficasStyles';

const CardGrasaVisceral = ({ rows, isLoad, paperStyle, lIcms, metabo }) => {
    const classes = GraficasStyles();

    return (
        <Paper>
            <Typography className={classes.title} color='primary'>Grasa Visceral</Typography>

            <Grid container spacing={2}>
                {/* Columna para la tabla */}
                <Grid item xs={12} lg={12} style={{ padding: '0% 20%' }} >
                    <Paper className={paperStyle} >
                        <Table size="small">
                            <TableHead>
                                <TableRow alignItems="center">
                                    <TableCell align="center">Fecha</TableCell>
                                    <TableCell align="center">Grasa Visceral</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {isLoad ? (
                                    <TableRow>
                                        <TableCell colSpan={2} align="center">Cargando...</TableCell>
                                    </TableRow>
                                ) : (
                                    rows.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell align="center">{UtilsTable().validateRowsTable(UtilsDate().formatDDMMMYYYY(new Date(row.datecreate)))}</TableCell>
                                            <TableCell align="center">{UtilsTable().validateRowsTable(row.visceral_fat_level)}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default CardGrasaVisceral;
